export const chartConfigToUrl = (chartConfig) => {
    const url = new URL('https://quickchart.io/chart');
    url.searchParams.set('c', JSON.stringify(chartConfig));
    url.searchParams.set('w', '500');
    url.searchParams.set('h', '300');
    url.searchParams.set('bkg', '#ffffff');
    url.searchParams.set('f', 'png');
    url.searchParams.set('v', '2');
    return url.href;
};